import * as XLSX from 'xlsx';

export const getHeaderCompatibleToCsv = () => [
  'first_name',
  'last_name',
  'id_from_employer',
  'sub_entity',
  'sub_entity_2',
  'company_email',
  'personal_email',
  'phone',
  'address',
  'date_of_birth',
  'gender',
  'plan_id',
  'plan_market',
  'employment_type',
  'wage_type',
  'custom_class_category',
  'salary',
  'hire_date',
  'eligibility_start_date',
];

const readCellText = (sheet: XLSX.WorkSheet, row: number, column: number) => {
  // eslint-disable-next-line id-length
  const address = XLSX.utils.encode_cell({ r: row, c: column });
  const cell: XLSX.CellObject | undefined = sheet[address];
  return String(cell?.v ?? '');
};

export const isValidRosterSheet = (sheet: XLSX.WorkSheet) =>
  readCellText(sheet, 0, 0).startsWith('First Name') &&
  readCellText(sheet, 1, 0) === '' &&
  readCellText(
    sheet,
    0,
    getHeaderCompatibleToCsv().indexOf('plan_market')
  ).startsWith('Current Plan Market');
